import { Appliance } from '../classes/appliances/Appliance'
import { AppliancePanel } from './AppliancePanel'

export interface ApplianceDataTableProps {
  appliances: Appliance[]
  link?: string
}

export function ApplianceDataTable(props: ApplianceDataTableProps): React.ReactElement {

  const { appliances, link } = props

  return (
    <>
      {appliances.map(appliance => (
        <AppliancePanel
          key={appliance.id}
          appliance={appliance}
          url={link?.replace(':id', `${appliance.id}`)}
        />
      ))}
    </>
  )
}
